import styled from "styled-components";

export const MissionProgressBarStyled = styled.div`
  width: 100%;

  .progress_track {
    height: ${({ $height }) => ($height != null ? `${$height}px` : "12px")};
    border-radius: 999px;
    background: ${({ $trackBg, theme }) => $trackBg || theme.COLORS.GRAY_22};
    overflow: hidden;
  }

  .progress_fill {
    height: 100%;
    max-width: 100%;
    border-radius: 999px;
    background: linear-gradient(
      90deg,
      ${({ theme }) => theme.COLORS.BLUE_21} 0%,
      ${({ theme }) => theme.COLORS.BLUE_21} 100%
    );
    transition: width 0.2s ease;
  }
`;
